import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import CreatorDashboard from "../dashboards/CreatorDashboard";
import ProfessionalDashboard from "../dashboards/ProfessionalDashboard";
import ManagerDashboard from "../pages/ManagerDashboard";

// Choisit le dashboard selon le CONTEXTE utilisateur (active_space), jamais selon l'URL.
export default function DashboardRouter() {
  const { identity, activeSpace } = useAuth();
  if (!identity) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>;
  }
  const space = activeSpace || identity.active_profile || "CREATOR";
  if (space === "MANAGER") return <ManagerDashboard />;
  if (space === "PROFESSIONAL") return <ProfessionalDashboard />;
  return <CreatorDashboard />;
}
